<template>
<div>
	<div class="detail wp-width">
		<div class="detail-container">
			<div class="go-back">
			<span @click="goBack"> {{ $t('Back') }}</span>
		    </div>
			<div class="container-two">
				<img src="../assets/img/done.png" alt="">
				<span> {{$t('Thank You')}} </span>
				<span> {{$t('Your order has been received')}} </span>

			</div>
			<div class="container-three">
					<span> {{$t('Order Details')}} </span>

				<div class="details">
					<div>
						<span> {{$t('Order number')}} :</span>
						<span>{{ plan.order_no}} </span>
					</div>
					<div>
						<span> {{$t('Date')}} :</span>
						<span>{{ plan.created_date }} </span>
					</div>
					<div>
						<span> {{$t('Payment method')}} :</span>
						<span>{{ plan.member_pay_method==2?$t('Alipay'):plan.member_pay_method==1?$t('Credit Card'):$t('Wechatpay')}}</span>
					</div>
				</div>
				<div class="total">
					<span> {{$t('Total')}}: </span>
					<span> ${{ plan.price }} USD </span>
				</div>


			</div>
			<div class="container-four">
				<span> {{$t('Customer Details')}} </span>
				<div>
					<div>
						<span> {{$t('Contact Information')}} </span>
						<span> {{ $t('E-mail')}}: {{ plan.email}} </span>
						<span> {{ $t('Phone')}}: {{plan.mobile}} </span>
					</div>
					<div>
						<span> {{$t('Payment Method')}} </span>
						<span>
							<div class="danbosm" v-if="plan.member_pay_method=='1'"><img class="tupiam flg" src="../assets/img/color.png" alt=""><span>{{plan.member_pay_method_name}}</span></div>
              <div class="danbosm" v-if="plan.member_pay_method=='2'"><img class="alipay flg" src="../assets/img/ali_logo.png" alt=""><span>{{plan.member_pay_method_name}}</span></div>
              <div class="danbosm" v-if="plan.member_pay_method=='3'"><img class="alipay flg" src="../assets/img/wx_logo.png" alt=""><span>{{plan.member_pay_method_name}}</span></div>
						</span>
						<!-- <span class="expriescss" v-if="plan.member_pay_method=='1'">  {{  $t('Expires')  }}:{{ plan.card_expire }} </span> -->
					</div>
				</div>

			</div>


			<!-- <div class="detail-left">
				<div class="detail-date">{{plan.title}} {{ $t('Pass') }}</div>
				<span class="kind">({{ plan.kids + (plan.kids>1?' kids':' kid') }})</span>
				<div class="price">
					<span
						>{{ plan.price }}<span>{{ '/Month' }}</span></span
					>
				</div>
			</div>
			<div class="detail-right">
				<span class="detail-title">{{ 'Next billing date: ' }}</span>
				<span class="detail-date">{{ plan.renew_at }}</span>
				<div class="detail-link">
					<router-link to="history/charges">{{ $t('view charges') }}</router-link>
					<router-link to="history/billing">{{ $t('view billing history') }}</router-link>
				</div>
				<div  class="divtwo" style="margin-top:20px;margin-bottom:20px;">
					<span class="detail-title"> {{$t('Pass expire date :')}} </span>
					<span class="detail-date">{{ plan.member_expire_at}}</span>
				</div>
				<span class="detail-pay">{{ $t('Payment method') }}:</span>
				<div class="detail-pay-content">
					<img src="../assets/img/502.png" alt="" />
					<div>
						<span class="detail-list-1">{{ plan.member_pay_method }}</span> -->
						<!-- <span class="detail-list-2">{{ $t('Expires') + ':' + plan.member_expire_at }}</span>
						<span class="detail-list-3">{{ $t('Update') }}</span> -->
					<!-- </div>
				</div>
			</div>  -->


		</div>
		<div class="plannow">
			<div class="plan-message">
			<span style="">{{ $t('advisor') }}&nbsp;</span>
			<!-- <span>{{ $t('Pls contact our advisor for assistance') }}</span> -->
		</div>
		<wp-mandy v-if="device === 'pc'"></wp-mandy>
		<div class="mandy" v-else>
			<wp-mandy-mini :radius="true"></wp-mandy-mini>
		</div>
		</div>


		<!-- <div class="round"></div> -->
	</div>
	<div class="foot">
				<wp-footer></wp-footer>
	</div>
</div>
</template>

<script>
	import WpMandy from '../components/WpMandy.vue';

	import { getMyPlanList,getUserInfo,getPayOrderDetail } from '../api';
	import WpMandyMini from '../components/WpMandyMini.vue';
	import { clearStore, getStore, setStore } from '../store';
	import WpFooter from '@/components/WpFooter.vue';
	export default {
		components: { WpMandy, WpMandyMini,WpFooter },
		data() {
			return {
				plan: [],
				user:{},
			};
		},
		computed: {
			device() {
				return window.innerWidth > 768 ? 'pc' : 'mobile';
			},
		},
		async mounted() {
			 this.plan= await getPayOrderDetail();
			 console.log(this.plan)
			await this.gitdataint();
			// var m =await this.openCenter()


		},
		methods:{
			goBack() {
				this.$router.push('/')
				// history.back();
			},
			// openCenter() {
			// 	 const loading = this.$loading({
			// 		lock: true,
			// 		text: getStore('lang')=='en'?'Status acquisition in progress...':'支付状态获取中...',
			// 		spinner: 'el-icon-loading',
			// 		background: 'rgba(0, 0, 0, 0.7)'
			// 		});
			// 		setTimeout(() => {
			// 			if(this.plan!=''){
			// 			loading.close();
			// 			}
			// 		}, 4000);

			// },
			gitdataint(){
				console.log(this.plan)
				// var loading
			if(this.plan==''||!this.plan){
				var loading = this.$loading({
					lock: true,
					text: getStore('lang')=='en'?'Status acquisition in progress...':'支付状态获取中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
					});
			}

				var enternt = setTimeout(async() => {

					 this.plan= await getPayOrderDetail();
					//  this.user= getStore('userinfo')
					//  console.log(this.user)
						if(this.plan){
							// console.log(this.plan)
						 clearTimeout(enternt)
						 loading.close();
						}
					}, 2000);
			}
		},
	};
</script>

<style lang="less" scoped>
.expriescss{
	font-size: 16px;
	line-height: 24px;
	color: #6B7280;
}
.detail{
	width: 90vw;
}
.detail-container {
		margin-top: 75px;
		// height: 291px;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;

		> div {
			flex-grow: 2;
		}
	}


	@media screen and (min-width: @device) {
		.plannow{
			width: 950px;
			margin: 0 auto;
		}
		.foot{
			margin-top: 59px;
		}
		.container-two{
			text-align: center;
			img{
				width: 53px;
				height: 53px;
			}
			span{
				display: block;
				font-family: 'Sofia Pro';
				font-style: normal;
				font-weight: 700;
				font-size: 36px;
				line-height: 44px;
				color: #111827;
			}
		}
		.container-three{
			margin: 0 auto;
			margin-top: 146px;
			width: 924px;
           height: 379px;
		   background: #FFFFFF;
			border: 1px solid #D8D8D8;
			border-radius: 5px;
			padding: 29px 33px;
			span{
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 700;
				font-size: 20px;
				line-height: 28px;
			}
			.details{
				margin-top: 30px;
				// display: flex;
				// flex-direction:column;
				div{

					display: flex;
					flex-direction: row;
					justify-content:space-between;

					span{
						width: 200px;
						margin-bottom: 20px;
						font-family: 'Microsoft YaHei';
						font-style: normal;
						font-weight: 400;
						font-size: 20px;
						line-height: 28px;
						color: #111827;
					}
					span:nth-child(2){
							font-weight: 400;
							font-size: 16px;
							line-height: 24px;
							color: #6B7280;
							text-align: right;
						}
				}

			}
			.total{
				margin-top: 48px;
				padding-top: 48px;
				border-top: 1px dashed #6B7280;
				display: flex;
				justify-content: flex-end;
				span{
					font-size: 24px;
					line-height: 24px;
				}

				span:nth-child(1){
					margin-right: 70px;
					font-weight: 400;
					font-size: 20px;
					line-height: 28px;
				}
			}

		}
		.container-four{
			width: 924px;
			margin: 75px auto 110px;
			span{
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 700;
				font-size: 20px;
				line-height: 28px;
				color: #000000;

			}
			div{
				display: flex;
				div{
					margin-top: 42px;
					display: flex;
					flex-direction :column;
					text-align: left;
					// align-items: center;
					margin-right: 40px;
					span{
						line-height: 28px;
						color: #111827;
						font-style: normal;
							font-family: 'Microsoft YaHei';
						font-weight: 400;
						font-size: 16px;
						line-height: 28px;
						margin-top: 16px;
						div{
							display: flex;
							flex-direction :row;
							align-items: center;
							margin: 0;
							position: relative;
							span{
								margin: 0;
							}
							img{
								height: 23px;
								margin-right: 10px;

							}
						}
					}
					span:nth-child(1){
						font-family: 'Inter';
						font-weight: 700;
						font-size: 18px;

					}
					.expriescss{
						font-size: 16px;
						line-height: 24px;
						color: #6B7280;
						margin: 0;
					}
				}
			}
		}
		.detail-left,
		.detail-right {
			padding-left: 91px;
		}

		.detail-date {
			// width: 227px;
			// height: 93px;
		}

		.kind {
			margin-top: 52px;
		}

		// .detail .plan-message {
		// 	margin-top: 30px;
		// }

		.round {
			position: absolute;
			width: 585px;
			height: 585px;
			left: -84px;
			top: -140px;

			background: #f2f9ff;
			border: 46.6311px solid #f2f9ff;
			box-sizing: border-box;
			border-radius: 666.159px;
			z-index: -1;
		}
	}

	@media screen and (max-width: @device) {
		.detail{
			width: 100vw;
		}
		.detail-container{
			margin-top: 42px;
		}
		.container-two{
			margin-top: 23px;
			text-align: center;
			img{
				width: 2.7rem;
				height:2.7rem;
			}
			span{
				display: block;
				font-family: 'Sofia Pro';
				font-style: normal;
				font-weight: 800;
				font-size: 20px;
				line-height: 30px;
				color: #111827;
			}
		}
		.container-three{
			margin: 0 auto;
			margin-top: 98px;
			width: 32rem;
           height: 35rem;
		   background: #FFFFFF;
			border: 1px solid #D8D8D8;
			border-radius: 5px;
			padding: 29px 10px;
			span{
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 700;
				font-size: 20px;
				line-height: 28px;
			}
			.details{
				margin-top: 30px;
				// display: flex;
				// flex-direction:column;
				div{

					display: flex;
					flex-direction: row;
					justify-content:space-between;
					span{
						width: 200px;
						margin-bottom: 20px;
						font-family: 'Microsoft YaHei';
						font-style: normal;
						font-weight: 400;
						font-size: 14px;
						line-height: 28px;
						color: #111827;
					}
					span:nth-child(2){
						font-size: 15px;
						line-height: 24px;
						color: #6B7280;
						text-align: right;
					}
				}

			}
			.total{
				margin-top: 48px;
				padding-top: 48px;
				border-top: 1px dashed #6B7280;
				display: flex;
				justify-content: flex-end;
				span:nth-child(1){
					margin-right: 70px;

				}
			}

		}
		.container-four{
			width: 32rem;
			margin: 35px auto 110px;
			span{
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 700;
				font-size: 20px;
				line-height: 28px;
				color: #000000;
				text-align: left;

			}
			div{
				display: flex;
				flex-direction :column;

				div{
					margin-top: 42px;
					display: flex;
					flex-direction :column;
					margin-right: 40px;
					span{
						line-height: 28px;
						color: #111827;
						font-style: normal;
							font-family: 'Microsoft YaHei';
						font-weight: 400;
						font-size: 16px;
						line-height: 28px;
						margin-top: 16px;
						div{
							display: flex;
							flex-direction :row;
							margin: 0;
							align-items: center;
							position: relative;
							span{
								margin: 0;
							}
							img{
								height: 2rem;
								margin-right: 10px;

							}
						}
					}
					span:nth-child(1){
						font-family: 'Inter';
						font-weight: 700;
						font-size: 18px;
					}
					.expriescss{
						font-size: 16px;
						line-height: 24px;
						color: #6B7280;
						margin: 0;
					}
				}
			}
		}
		.detail-left,
		.detail-right {
			align-items: center;
		}

		.kind {
			margin-top: 8px;
		}

		.detail-right {
			margin-top: 30px;
		}

		.detail-pay-content {
			border: 1px solid #e8e8e8;
			border-radius: 10px;
			padding: 20px;
			box-sizing: border-box;
			width: 90%;
		}
		.plan-message {
			margin: 0 auto;
			margin-top: 20px;
			width: 332px;
			text-align: left;


		}
		.detail-right {
			.divtwo{
				text-align: center;
			}
		}
	}



	.detail-left {
		// padding-left: 91px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.kind {
			font-weight: 500;
			font-size: 17px;
			line-height: 17px;
			// margin-top: 25px;
		}

		.price {
			color: #4b69fe;
			margin-top: 30px;

			span {
				font-weight: 600;
				font-size: 40px;
				line-height: 40px;

				> span {
					font-weight: 500;
					font-size: 15px;
				}
			}
		}

		.detail-date {
			font-weight: bold;
			font-size: 45px;
			line-height: 52px;
			// width: 227px;
			// height: 93px;
		}
	}

	.detail-right {
		border-left: 1px solid #e6e6e6;
		// padding-left: 91px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.detail-title {
			font-weight: 600;
			font-size: 18px;
			line-height: 18px;
		}
		.divtwo{
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column;
		}
		.detail-date {
			font-weight: 600;
			font-size: 22px;
			line-height: 20px;
			color: #4b69fe;
			margin-top: 25px;
		}

		.detail-link {
			font-weight: 600;
			font-size: 13px;
			line-height: 14px;
			margin-top: 16px;
			color: #4b69fe;

			> *:first-child {
				margin-right: 5px;
			}

			> *:last-child {
				margin-left: 5px;
			}
		}

		.detail-pay {
			margin-top: 40px;
			font-weight: 600;
			font-size: 18px;
			line-height: 14px;
		}

		.detail-pay-content {
			font-size: 16px;
			line-height: 16px;
			display: flex;
			flex-direction: row;
			margin-top: 25px;

			> img {
				width: 27.86px;
				height: 15px;
			}

			> div {
				display: flex;
				flex-direction: column;
				padding-left: 12px;
				box-sizing: border-box;

				.detail-list-1 {
					font-size: 16px;
					line-height: 16px;
				}

				.detail-list-2 {
					font-size: 14px;
					line-height: 100%;
					color: #828282;
					margin-top: 10px;
				}

				.detail-list-3 {
					font-weight: 600;
					font-size: 16px;
					line-height: 16px;
					margin-top: 15px;
				}
			}
		}
	}

	.plan-message {
		font-family: 'Microsoft YaHei';
		font-style: normal;
		font-weight: 700;
		font-size: 20px;
		line-height: 28px;
		// text-align: center;
		display: flex;
		// justify-content: center;
		flex-wrap: wrap;
		span{
			font-weight: 700;
			font-family: 'Microsoft YaHei';
		}
	}

	.mandy {
		width: 90%;
		margin: 0 auto 50px;
	}
</style>



// WEBPACK FOOTER //
// src/views/PlanDetail.vue